module.exports = __webpack_public_path__ + "static/media/ParentLogo.652415f8.png";